import { APP_COLORS } from "../enums";

const customMuiTextField: any = {
  defaultProps: {
    fullWidth: true,
  },
  styleOverrides: {
    border: `1px solid ${APP_COLORS.borderLight2}`,
    root: {
      "& .MuiInputBase-root": {
        height: 40,
        width: "100%",
        borderRadius: 10,
        backgroundColor: APP_COLORS.white,
      },
      "& .MuiInputBase-multiline": {
        height: "auto",
      },
    },
  },
};

export { customMuiTextField };
